import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors } from '@/utils/constants';
import { em } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $category': {
      color: SecondaryColors.main,

      '&:hover': {
        color: SecondaryColors.light,
      },
    },
    '& $title': {
      color: TextColors.light,
    },
    '& $shortDescription': {
      color: TextColors.light,
    },
    '& $author': {
      color: TextColors.light,
    },
    '& $publicationDate': {
      color: TextColors.light,
    },
  },
};

const lightTheme = {
  root: {
    '& $category': {
      color: SecondaryColors.dark,

      '&:hover': {
        color: SecondaryColors.main,
      },
    },
    '& $title': {
      color: TextColors.dark,
    },
    '& $shortDescription': {
      color: TextColors.dark,
    },
    '& $author': {
      color: TextColors.dark,
    },
    '& $publicationDate': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      marginTop: muiTheme.spacing(3),

      [muiTheme.breakpoints.up('md')]: {
        marginTop: muiTheme.spacing(6),
      },
    },
    category: {
      '&.MuiTypography-root': {
        marginBottom: '8px',
        display: 'block',
        textDecoration: 'none',
      },
    },
    title: {
      '&.MuiTypography-root': {
        marginTop: 0,
        marginBottom: em({ size: 16, base: 36 }),
      },
    },
    shortDescription: {
      '&.MuiTypography-root': {
        marginTop: 0,
        marginBottom: em({ size: 16, base: 18 }),
      },
    },
    author: {
      marginTop: em({ size: 24, base: 13 }),
      marginBottom: em({ size: 32, base: 13 }),
    },
    publicationDate: {
      display: 'block',
      lineHeight: '1em',
      marginTop: '26px',
      marginBottom: '34px',

      [muiTheme.breakpoints.up('md')]: {
        marginTop: '30px',
        marginBottom: '48px',
      },
    },
    chips: {
      marginBottom: muiTheme.spacing(1.5),

      '& > *': {
        marginBottom: muiTheme.spacing(1),
      },
    },
  }),
  { name: 'GenBlogDetailHeader' },
);

export default useStyles;
